import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined'
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined'
import './index.css'

// List of month abbreviations for calendar display
const MONTHS: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/**
 * Calendar Navigation Bar
 * - Displays current month/year and back/forward controls
 * - Disables navigation outside of allowed date range
 */
const CalendarNavigationComponent = ({
  startDate,
  endDate,
  showDate,
  setShowDate,
}: {
  startDate: Date
  endDate: Date
  showDate: Date
  setShowDate: (date: Date) => void
}) => {
  // Determine if back/forward navigation should be disabled
  const isBackDisabled =
    showDate.getFullYear() < startDate.getFullYear() ||
    (showDate.getFullYear() === startDate.getFullYear() && showDate.getMonth() <= startDate.getMonth())

  const isForwardDisabled =
    showDate.getFullYear() > endDate.getFullYear() ||
    (showDate.getFullYear() === endDate.getFullYear() && showDate.getMonth() >= endDate.getMonth())

  return (
    <div className='navigation'>
      {/* Back button: go to previous month if allowed */}
      <div
        className={`back ${isBackDisabled ? 'disabled' : ''}`}
        data-testid='back-testid'
        onClick={() => {
          if (isBackDisabled) return
          const newDate = new Date(showDate)
          newDate.setMonth(newDate.getMonth() - 1)
          setShowDate(newDate)
        }}
      >
        <ChevronLeftOutlinedIcon style={{ fontSize: 24 }} />
        {/* Show previous month name */}
        {MONTHS[showDate.getMonth() === 0 ? 11 : showDate.getMonth() - 1]}
      </div>

      {/* Current month and year */}
      <div className='monthAndYear'>
        {MONTHS[showDate.getMonth()]} {showDate.getFullYear()}
      </div>

      {/* Forward button: go to next month if allowed */}
      <div
        className={`forward ${isForwardDisabled ? 'disabled' : ''}`}
        data-testid='forward-testid'
        onClick={() => {
          if (isForwardDisabled) return
          const newDate = new Date(showDate)
          newDate.setMonth(newDate.getMonth() + 1)
          setShowDate(newDate)
        }}
      >
        {/* Show next month name */}
        {MONTHS[showDate.getMonth() === 11 ? 0 : showDate.getMonth() + 1]}
        <ChevronRightOutlinedIcon style={{ fontSize: 24 }} />
      </div>
    </div>
  )
}

export default CalendarNavigationComponent
